/* globalmodule */
/* homemodule */
define( '../src/sublayouts/m27-accessibility-overlay/m27-accessibility-overlay',[ 'jquery', 'lib/utils' ], function ( $, utils ) {

	'use strict';

	/**
	 * Accessibility overlay  component.
	 * @exports M27_AccessibilityOverlay
	 * @constructor
	 */

	var M27_AccessibilityOverlay = function ( $component ) {

		this.$component = $component;

		return this;
	};

	/**
	 * Initialise component
	 */

	M27_AccessibilityOverlay.prototype.init = function () {
		var _this = this;
		var colour = this.getCookie("colour");
		var read = this.getCookie("read");
		var fontsize = this.getCookie("fontsize");
		var body = $('body');
		this.$ao = $('.m27-accessibility-overlay');
		this.$aob = $('.m27-accessibility-overlay__cta');

		var lang = utils.isRTL() ? 'ar_ar' : 'en_UK',
				voice = utils.isRTL() ? 'Faris' : 'en_gb_amy',
				pageurl = window.location.href;

		if (document.body.style.fontSize == "") {
			document.body.style.fontSize = "1em";
		}

		if (fontsize!="" && fontsize>0) {
			this.increaseFontSize(fontsize);
		}

		if (colour=="invert") {
			this.invertColour();
			this.$component.find('.form-field__input--radio').eq(0).prop('checked', false);
			this.$component.find('.form-field__input--radio').eq(2).prop('checked', false);
			this.$component.find('.form-field__input--radio').eq(3).prop('checked', false);
			this.$component.find('.form-field__input--radio').eq(1).prop('checked', true);
		}

		if (colour=="blue") {
			this.blueColour();
			this.$component.find('.form-field__input--radio').eq(0).prop('checked', false);
			this.$component.find('.form-field__input--radio').eq(1).prop('checked', false);
			this.$component.find('.form-field__input--radio').eq(3).prop('checked', false);
			this.$component.find('.form-field__input--radio').eq(2).prop('checked', true);
		}

		if (colour=="red") {
			this.redColour();
			this.$component.find('.form-field__input--radio').eq(0).prop('checked', false);
			this.$component.find('.form-field__input--radio').eq(1).prop('checked', false);
			this.$component.find('.form-field__input--radio').eq(2).prop('checked', false);
			this.$component.find('.form-field__input--radio').eq(3).prop('checked', true);
		}
		if (colour=="full") {
			this.$component.find('.form-field__input--radio').eq(1).prop('checked', false);
			this.$component.find('.form-field__input--radio').eq(2).prop('checked', false);
			this.$component.find('.form-field__input--radio').eq(3).prop('checked', false);
			this.$component.find('.form-field__input--radio').eq(0).prop('checked', true);
		}

		$('.readspeaker-link').attr('href', 'https://app.readspeaker.com/cgi-bin/rsent?customerid=7358&lang='+lang+'&voice='+voice+'&readid=rs_area&url='+pageurl);

		body.on('click', '.readspeaker-link', function () {
			$(window).trigger('readspeakerRequest');
		});

		$('html').on('click', function (e) {
			// hide if not a radio button
			var t = $(e.target);
			if ((t && t.attr('class') && t.attr('class').indexOf('radio') == -1) && (t && t.attr('class') && (t.attr('id') != 'MrSlCb')) && (t && t.attr('class') && (t.attr('id') != 'DeafTranslate')) && (t && t.attr('class') && (t.attr('id') != 'TranslateStop'))) {
				_this.hideOverlay();
			}
		});

		$('.m12-tools__link').on('focusin', function (e) {
			_this.hideOverlay();
		});

		this.$aob.on('click', function (e) {
			e.stopPropagation();
			e.preventDefault();
			if ($(this).hasClass('m12-menuover-accessibility')) {
				_this.toggleOverlay(true);
			} else {
				_this.toggleOverlay(false);
			}
			
		});

		$('.m27-accessibility-overlay__content').on('click','.form-field__radio', function (e) {
			switch (parseInt($(e.target).siblings(1).val())) {
				case 1:
					_this.fullColour();
					break;
				case 2:
					_this.invertColour();
					break;
				case 3:
					_this.blueColour();
					break;
				case 4:
					_this.redColour();
					break;
			}
		});

		$('.m27-accessibility-overlay__content').find('.m27-accessibility-overlay__text-smaller').on('click', function (e) {
			e.stopPropagation();
			e.preventDefault();
			_this.decreaseFontSize(1);
		});
		$('.m27-accessibility-overlay__content').find('.m27-accessibility-overlay__text-larger').on('click', function (e) {
			e.stopPropagation();
			e.preventDefault();
			_this.increaseFontSize(1);
		});
		$('.m27-accessibility-overlay__content').find('.m27-accessibility-overlay__button--print').on('click', function () {
			if (window.print) {
				window.print();
			}
		});

		$('.m27-accessibility-overlay__content').find('.readspeaker-link').on('click', function () {
			_this.hideReadSpeakerButton();
			_this.setCookie('read', 1, 1);
		});

		body.on('click', '.rsbtn_closer.rsimg', function () {
			_this.showReadSpeakerButton();
		});
	};

	M27_AccessibilityOverlay.prototype.hideOverlay = function () {
		this.$ao.removeClass('m27-accessibility-overlay--visible');
		this.$ao.removeClass('m27-accessibility-overlay--menuover');
		this.$ao.attr('aria-expanded', false);
		this.$aob.removeClass('m27-accessibility-overlay__cta--active');
	};

	M27_AccessibilityOverlay.prototype.showOverlay = function () {
		this.$ao.addClass('m27-accessibility-overlay--visible');
		this.$ao.attr('aria-expanded', true);
		this.$aob.addClass('m27-accessibility-overlay__cta--active');
	};

	M27_AccessibilityOverlay.prototype.toggleOverlay = function (ismenuOver) {
		if (ismenuOver) {
			if (this.$ao.hasClass('m27-accessibility-overlay--menuover')) {
				this.$ao.removeClass('m27-accessibility-overlay--menuover');
			} else {
				this.$ao.removeClass('m27-accessibility-overlay--menuover');
				this.$ao.addClass('m27-accessibility-overlay--menuover');
			}
		} else {
			this.$ao.removeClass('m27-accessibility-overlay--menuover');
		}

		if (this.$aob.hasClass('m27-accessibility-overlay__cta--active')) {
			this.$aob.removeClass('m27-accessibility-overlay__cta--active');
		} else {
			this.$aob.removeClass('m27-accessibility-overlay__cta--active');
			this.$aob.addClass('m27-accessibility-overlay__cta--active');
		}

		if (this.$ao.hasClass('m27-accessibility-overlay--visible')) {
			this.$ao.attr('aria-expanded', false);
			this.$ao.removeClass('m27-accessibility-overlay--visible');
		} else {
			this.$ao.removeClass('m27-accessibility-overlay--visible');
			this.$ao.addClass('m27-accessibility-overlay--visible');
			this.$ao.attr('aria-expanded', true);
		}

	};


	M27_AccessibilityOverlay.prototype.fullColour = function() {
		$('body').removeClass('invert').removeClass('blue').removeClass('blue').removeClass('red-weakness');
		this.setCookie("colour", "full", 1);
	};

	M27_AccessibilityOverlay.prototype.invertColour = function() {
		$('body').removeClass('blue').removeClass('red-weakness').addClass('invert');
		this.setCookie("colour", "invert", 1);
	};

	M27_AccessibilityOverlay.prototype.blueColour = function() {
		$('body').removeClass('invert').removeClass('red-weakness').addClass('blue');
		this.setCookie("colour", "blue", 1);
	};

	M27_AccessibilityOverlay.prototype.redColour = function() {
		$('body').removeClass('blue').removeClass('invert').addClass('red-weakness');
		this.setCookie("colour", "red", 1);
	};

	M27_AccessibilityOverlay.prototype.hideReadSpeakerButton = function() {
		$('.readspeaker-link').css('display', 'none');
	};

	M27_AccessibilityOverlay.prototype.showReadSpeakerButton = function() {
		$('.readspeaker-link').css('display', 'block');
	};

	M27_AccessibilityOverlay.prototype.increaseFontSize = function resizeText(multiplier) {
		if (document.body.style.fontSize == "1em" ) {
			document.body.style.fontSize = parseFloat(document.body.style.fontSize) + (multiplier * 0.2) + "em";
			this.setCookie("fontsize", multiplier, 1);
			setTimeout(function() {
				$(window).trigger('resize');
			},100)
		}
	};

	M27_AccessibilityOverlay.prototype.decreaseFontSize = function resizeText(multiplier) {
		if (document.body.style.fontSize != "1em" ) {
			document.body.style.fontSize = parseFloat(document.body.style.fontSize) - (multiplier * 0.2) + "em";
			this.setCookie("fontsize", 0, 0);
			setTimeout(function() {
				$(window).trigger('resize');
			},100)
		}
	};

	M27_AccessibilityOverlay.prototype.setCookie = function (cname, cvalue, exdays) {
		var d = new Date();
		d.setTime(d.getTime() + (exdays*24*60*60*1000));
		var expires = "expires="+d.toUTCString();
		document.cookie = cname + "=" + cvalue + ";path=/; " + expires;
	};

	M27_AccessibilityOverlay.prototype.getCookie = function(cname) {
		var name = cname + "=";
		var ca = document.cookie.split(';');
		for(var i=0; i<ca.length; i++) {
			var c = ca[i];
			while (c.charAt(0)==' ') c = c.substring(1);
			if (c.indexOf(name) == 0) return c.substring(name.length,c.length);
		}
		return "";
	};

	return M27_AccessibilityOverlay;
} );
	
